/**
 * Fixed avatar colors to ensure contrast and prevent CSS injection.
 */
export const AVATAR_COLORS = [
  'blue',
  'indigo',
  'violet',
  'magenta',
  'slate',
  'navy',
  'plum',
  'steel',
] as const

export type AvatarColorName = (typeof AVATAR_COLORS)[number]

export function isAvatarColorName(value: string): value is AvatarColorName {
  return (AVATAR_COLORS as readonly string[]).includes(value)
}

/** The CSS custom property backing a given swatch name. */
export function avatarColorVar(name: AvatarColorName): string {
  return `var(--avatar-${name})`
}

/**
 * Deterministic color fallback derived from user ID.
 */
export function defaultAvatarColor(seed: number | string): AvatarColorName {
  const n = typeof seed === 'number' ? seed : hashString(seed)
  return AVATAR_COLORS[Math.abs(n) % AVATAR_COLORS.length] as AvatarColorName
}

function hashString(value: string): number {
  let h = 0
  for (let i = 0; i < value.length; i++) {
    h = (h * 31 + value.charCodeAt(i)) | 0
  }
  return h
}
